import { useEffect } from "react";
import { useMap } from "react-leaflet";
import { enableProximityHover } from "../utils/leafletProximityHover";

/**
 * Enables proximity-based hover detection for all line layers on the map.
 * The underlying utility re-collects layers automatically on add/remove events,
 * so this hook only needs to run once.
 *
 * @param tolerance - Proximity detection distance in pixels (default: 15)
 */
export function useProximityHover(tolerance = 15) {
  const map = useMap();

  useEffect(() => {
    if (!map) return;
    return enableProximityHover(map, { tolerance });
  }, [map, tolerance]);
}
